export default "__VITE_ASSET__ee2f0fde__"